import React from 'react';
import { FormattedMessage } from 'react-intl';

export interface IFormattedText {
  displayName: string;
  formattedName: string;
}

interface IProps {
  displayName: string;
  formattedName?: string;
  style?: string;
  onClick?: () => void;
}

const FormattedText: React.SFC<IProps> = ({ 
  displayName,
  formattedName,
  style = '',
  onClick,
}) => {

  if (formattedName) {
    return (
      <span className={ style } onClick={ onClick }>
        <FormattedMessage id={ formattedName } defaultMessage={ displayName } />
      </span>
    );
  }
  
  return <span className={ style } onClick={ onClick }>{ displayName }</span>;
};
  
export default FormattedText;


// WEBPACK FOOTER //
// ./src/components/Shared/FormattedText/FormattedText.tsx